export default {
  loading: "Lade..."
};
